import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { filter, findIndex, groupBy } from 'lodash'
import { useTranslation } from 'react-i18next'
import { currency } from 'i18n/config'

const TicketTypesSelectList = ({ data, type, onTicketQtyChanged }) => {
  const { t, i18n } = useTranslation()

  const GroupItem = (props) => {
    const { tickets } = props
    const { group_name, group_id } = tickets[0]

    return (
      <ListGroupItem
        key={group_id}
        className="rounded-0 d-flex justify-content-between flex-column flex-md-row"
      >
        <div className="p-2 pb-3 align-self-center text-center text-md-start">
          <strong style={{ fontWeight: 'bold' }}>{group_name}</strong>
        </div>

        <div className="d-flex justify-content-end align-self-center flex-column flex-sm-row">
          <select
            name="select"
            data-group-id={group_id}
            onChange={(e) => {
              const newtickets = [...data]

              if (!e.target.value) {
                newtickets
                  .filter(
                    (ticket) =>
                      ticket.group_id ===
                      parseInt(e.target.getAttribute('data-group-id'))
                  )
                  .forEach((ticket) => {
                    const temporalIndex = findIndex(newtickets, { id: ticket.id })
                    newtickets[temporalIndex].qty = 0
                  })
                return onTicketQtyChanged(newtickets)
              }

              const indexChanged = findIndex(
                newtickets,
                { id: parseInt(e.target.value) }
              )

              newtickets.forEach((ticket) => {
                if (ticket.group_id === newtickets[indexChanged].group_id) {
                  const temporalIndex = findIndex(newtickets, { id: ticket.id })
                  newtickets[temporalIndex].qty = 0
                }
              })

              newtickets[indexChanged].qty = 1
              onTicketQtyChanged(newtickets)
            }}
          >
            <option value="">{i18n.t('ticket_types_select_list.none', { defaultValue: 'No one' })}</option>
            {tickets.map((ticket) => {
              const { id, name, total_price, qty } = ticket
              return (
                <option key={id} value={id} selected={qty > 0}>
                  {name} - {currency(total_price)}
                </option>
              )
            })}
          </select>
        </div>
      </ListGroupItem>
    )
  }

  return (
    <ListGroup>
      {Object.values(groupBy(data, 'group_id')).map((tickets, i) => (
        <GroupItem tickets={tickets} key={i} />
      ))}
    </ListGroup>
  )
}

export default TicketTypesSelectList